export const baseData = {
  title: "CATEGORY VENDOR"
}